module.exports = __webpack_public_path__ + "static/media/Profile.bc0973f0.svg";